import { render } from "./BaseSkeleton.vue?vue&type=template&id=eaa807a4&scoped=true&ts=true"
import script from "./BaseSkeleton.vue?vue&type=script&lang=ts"
export * from "./BaseSkeleton.vue?vue&type=script&lang=ts"

import "./BaseSkeleton.vue?vue&type=style&index=0&id=eaa807a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaa807a4"]])

export default __exports__